import { render, staticRenderFns } from "./merchantAuthentication.vue?vue&type=template&id=7666c8f1&scoped=true"
import script from "./merchantAuthentication.vue?vue&type=script&lang=js"
export * from "./merchantAuthentication.vue?vue&type=script&lang=js"
import style0 from "./merchantAuthentication.vue?vue&type=style&index=0&id=7666c8f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7666c8f1",
  null
  
)

export default component.exports